/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Revertscheduledchangeconfirmdescription4Inputs */

const en_revertscheduledchangeconfirmdescription4 = /** @type {(inputs: Revertscheduledchangeconfirmdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your current plan continues unchanged and the scheduled change is discarded.`)
};

const de_revertscheduledchangeconfirmdescription4 = /** @type {(inputs: Revertscheduledchangeconfirmdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein aktueller Plan läuft unverändert weiter, der geplante Wechsel wird verworfen.`)
};

/**
* | output |
* | --- |
* | "Your current plan continues unchanged and the scheduled change is discarded." |
*
* @param {Revertscheduledchangeconfirmdescription4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const revertscheduledchangeconfirmdescription4 = /** @type {((inputs?: Revertscheduledchangeconfirmdescription4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Revertscheduledchangeconfirmdescription4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_revertscheduledchangeconfirmdescription4(inputs)
	return de_revertscheduledchangeconfirmdescription4(inputs)
});
export { revertscheduledchangeconfirmdescription4 as "revertScheduledChangeConfirmDescription" }